<template>
  <div
    class="flex w-full border border-black-10 bg-lightGold-20 p-2 shadow sm:border-none sm:bg-transparent sm:py-3 sm:pl-0 sm:pr-3 sm:shadow-none"
  >
    <div>
      <Skeleton type="custom" class="h-40 w-[120px] shrink-0 sm:h-56 sm:w-40" />
      <Skeleton type="custom" class="mt-2 h-8 sm:hidden" />
    </div>
    <div class="ml-5 flex grow justify-between gap-1">
      <div class="flex flex-col">
        <Skeleton type="custom" class="mt-1 h-[22px] w-40 lg:w-36" />
        <div class="mt-1.5 flex space-x-1 *:h-4 sm:hidden">
          <Skeleton type="custom" class="w-14" />
          <Skeleton type="custom" class="w-14" />
        </div>
        <div class="flex h-full flex-col justify-between">
          <div class="mt-5 space-y-2">
            <div class="flex space-x-1 *:h-4">
              <Skeleton type="custom" class="w-20" />
              <Skeleton type="custom" class="w-14" />
            </div>

            <div class="flex space-x-1 *:h-4">
              <Skeleton type="custom" class="w-10" />
              <Skeleton type="custom" class="w-5" />
            </div>
            <div class="flex space-x-1 *:h-4">
              <Skeleton type="custom" class="w-10" />
              <Skeleton type="custom" class="w-7" />
            </div>
            <Skeleton type="custom" class="!mt-4 block h-3 w-32 sm:hidden" />
          </div>
          <div class="hidden space-y-2 sm:block">
            <Skeleton type="custom" class="h-4 w-40" />
            <div class="flex space-x-3 *:h-4">
              <Skeleton type="custom" class="w-20" />
              <Skeleton type="custom" class="w-40" />
            </div>
          </div>
        </div>
      </div>
      <div class="hidden flex-col justify-between sm:flex">
        <div class="flex justify-end gap-x-2">
          <Skeleton type="custom" class="max-lg:hidden h-9 w-[68px]" />
        </div>
        <div class="flex flex-col items-end space-y-1">
          <Skeleton type="custom" class="h-4 w-10" />
          <Skeleton type="custom" class="h-4 w-10" />
        </div>
      </div>
    </div>
  </div>
</template>
